import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface Props {
  fixedWidth?: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'FontAwesomeIcon',
  props: {
    fixedWidth: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("i", {
    class: _normalizeClass({'fa-fw': props.fixedWidth})
  }, null, 2 /* CLASS */))
}
}

})